import React from 'react';
import { Tabs } from 'antd';

const TabsWrapper = ({ TabsData, ...data }: any) => {

  return <div className="kx_tabs_box">
    <Tabs  {...data}>
      {
        TabsData?.map(({ title, key }: any) => {
          return <Tabs.TabPane tab={title} key={key} />
        })
      }
    </Tabs>
  </div>
}

export default TabsWrapper